// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SimulationTrackerOutput } from "./SimulationTrackerOutput";
import {
  SimulationTrackerOutputFromJSON,
  SimulationTrackerOutputFromJSONTyped,
  SimulationTrackerOutputToJSON,
  SimulationTrackerOutputToJSONTyped,
} from "./SimulationTrackerOutput";
import type { SimulationTrackerInput } from "./SimulationTrackerInput";
import {
  SimulationTrackerInputFromJSON,
  SimulationTrackerInputFromJSONTyped,
  SimulationTrackerInputToJSON,
  SimulationTrackerInputToJSONTyped,
} from "./SimulationTrackerInput";

/**
 *
 * @export
 * @interface SimulationTrackerSchema
 */
export interface SimulationTrackerSchema {
  /**
   *
   */
  tag: SimulationTrackerSchemaTagEnum;
  /**
   *
   */
  inputs: SimulationTrackerInput;
  /**
   *
   */
  outputs: SimulationTrackerOutput;
}

/**
 * @export
 */
export const SimulationTrackerSchemaTagEnum = {
  SimulationTracker: "simulation_tracker",
} as const;
export type SimulationTrackerSchemaTagEnum =
  (typeof SimulationTrackerSchemaTagEnum)[keyof typeof SimulationTrackerSchemaTagEnum];

/**
 * Check if a given object implements the SimulationTrackerSchema interface.
 */
export function instanceOfSimulationTrackerSchema(value: object): value is SimulationTrackerSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "simulation_tracker") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function SimulationTrackerSchemaFromJSON(json: any): SimulationTrackerSchema {
  return SimulationTrackerSchemaFromJSONTyped(json, false);
}

export function SimulationTrackerSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulationTrackerSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: SimulationTrackerInputFromJSON(json["inputs"]),
    outputs: SimulationTrackerOutputFromJSON(json["outputs"]),
  };
}

export function SimulationTrackerSchemaToJSON(json: any): SimulationTrackerSchema {
  return SimulationTrackerSchemaToJSONTyped(json, false);
}

export function SimulationTrackerSchemaToJSONTyped(
  value?: SimulationTrackerSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: SimulationTrackerInputToJSON(value["inputs"]),
    outputs: SimulationTrackerOutputToJSON(value["outputs"]),
  };
}
